import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { posts } from '../data/posts';
import BlogLayout from '../components/BlogLayout';

export default function BlogIndex() {
  useEffect(() => {
    document.title = 'Blog | Evolve Media Agency — Amazon & Ecommerce Strategy';
    const link = document.querySelector("link[rel='canonical']") || document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', 'https://evolvemediaagency.com/blog');
    if (!document.querySelector("link[rel='canonical']")) document.head.appendChild(link);
  }, []);

  const sorted = [...posts].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

  return (
    <BlogLayout>
    <div style={{ fontFamily: 'Montserrat, sans-serif', color: '#1a1a1a' }}>
      {/* Hero */}
      <section style={{ background: '#000', color: '#fff', padding: '80px 24px', textAlign: 'center' }}>
        <p style={{ color: '#01c61f', fontWeight: 800, fontSize: '13px', letterSpacing: '2px', textTransform: 'uppercase', margin: '0 0 16px' }}>EVOLVE MEDIA BLOG</p>
        <h1 style={{ fontWeight: 900, fontSize: 'clamp(2rem, 5vw, 3.2rem)', lineHeight: 1.1, maxWidth: '700px', margin: '0 auto 20px' }}>
          The Ecommerce Growth Blog
        </h1>
        <p style={{ color: '#aaa', fontSize: '1.1rem', maxWidth: '560px', margin: '0 auto 36px', lineHeight: 1.7 }}>
          Strategy, content, and creative insights for Amazon sellers, TikTok Shop brands, and Shopify operators building real businesses in 2026.
        </p>
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <a href="https://calendly.com/evolvemedia/amz-30-min" target="_blank" rel="noopener noreferrer"
            style={{ background: '#01c61f', color: '#fff', padding: '14px 28px', borderRadius: '9999px', fontWeight: 700, fontSize: '15px', textDecoration: 'none' }}>
            Book a Free Strategy Call
          </a>
          <a href="https://www.emapdf.com/" target="_blank" rel="noopener noreferrer"
            style={{ background: '#6aa7f0', color: '#fff', padding: '14px 28px', borderRadius: '9999px', fontWeight: 700, fontSize: '15px', textDecoration: 'none' }}>
            Get the Free Ecom Profit Box
          </a>
        </div>
      </section>

      {/* Grid */}
      <section style={{ maxWidth: '1200px', margin: '0 auto', padding: '64px 24px' }}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {sorted.map(post => (
            <article key={post.slug} style={{ background: '#fff', border: '1px solid #e8e8e8', borderRadius: '16px', overflow: 'hidden', transition: 'all .2s', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', cursor: 'pointer' }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.12)';
                e.currentTarget.style.transform = 'translateY(-4px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.06)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}>
              <Link to={`/blog/${post.slug}`} style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
                <div style={{ padding: '32px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px' }}>
                    <span style={{ background: post.categoryColor, color: '#fff', padding: '3px 12px', borderRadius: '9999px', fontSize: '12px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.5px' }}>
                      {post.category}
                    </span>
                    <span style={{ color: '#aaa', fontSize: '13px' }}>{post.readTime}</span>
                  </div>
                  <h2 style={{ fontWeight: 800, fontSize: '1.25rem', lineHeight: 1.3, margin: '0 0 14px', color: '#1a1a1a', transition: 'color .2s' }}
                    onMouseEnter={(e) => e.currentTarget.style.color = '#01c61f'}
                    onMouseLeave={(e) => e.currentTarget.style.color = '#1a1a1a'}>
                    {post.title}
                  </h2>
                  <p style={{ color: '#666', fontSize: '1rem', lineHeight: 1.7, margin: '0 0 20px' }}>{post.excerpt}</p>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ color: '#aaa', fontSize: '13px' }}>{post.date}</span>
                    <span style={{ color: '#01c61f', fontWeight: 700, fontSize: '14px' }}>
                      Read More →
                    </span>
                  </div>
                </div>
              </Link>
            </article>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section style={{ background: '#f7f7f7', padding: '64px 24px', textAlign: 'center' }}>
        <h2 style={{ fontWeight: 900, fontSize: '2rem', margin: '0 0 16px' }}>Want the Full Playbooks?</h2>
        <p style={{ color: '#666', fontSize: '1.05rem', maxWidth: '480px', margin: '0 auto 32px', lineHeight: 1.7 }}>
          10 step-by-step guides covering product launches, listing optimization, TikTok growth, email marketing, and more. Free.
        </p>
        <a href="https://www.emapdf.com/" target="_blank" rel="noopener noreferrer"
          style={{ background: '#01c61f', color: '#fff', padding: '16px 36px', borderRadius: '9999px', fontWeight: 800, fontSize: '16px', textDecoration: 'none' }}>
          Get the Free Ecom Profit Box
        </a>
      </section>
    </div>
    </BlogLayout>
  );
}
